import React from 'react';
import { ownerVerifiedContent } from './contentConfig';

const TransparencyV2 = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container px-4 md:px-6 mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl mb-6">
            Como a recomendação é construída e como a relação é remunerada.
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Antes de qualquer contratação, informamos quem participa da operação, quais serviços são prestados, quais custos podem existir e como a consultoria é remunerada. Se houver comissão, indicação, parceria, honorário ou outro incentivo econômico, isso será informado em linguagem direta. Se não houver remuneração em uma etapa, isso também será declarado.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm">
            <h3 className="font-semibold mb-2">Modelo de remuneração</h3>
            <p className="text-muted-foreground">{ownerVerifiedContent.compensationModel}</p>
          </div>
          
          <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm">
            <h3 className="font-semibold mb-2">Há comissão ou indicação?</h3>
            <p className="text-muted-foreground">[CONFIRMAR: detalhamento sobre administradora, corretora, parceiro]</p>
          </div>
          
          <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm">
            <h3 className="font-semibold mb-2">Custos da operação</h3>
            <p className="text-muted-foreground">[CONFIRMAR: quais são pagos ao consultor e quais a terceiros]</p>
          </div>
          
          <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm">
            <h3 className="font-semibold mb-2">Transparência de contratos</h3>
            <p className="text-muted-foreground">[CONFIRMAR: Quando o cliente recebe contratos, regulamentos, tabelas e documentos]</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransparencyV2;
